import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import classNames from 'classnames';

import { EventsState } from '../../../../../store/types';
import { ColorKeys, PageModule, sortQuestionsOptions, TextOverrides } from '../../../../../types/working-model';
import { GetDefaultQuestion } from '../../../../../store/utils/create-event';
import '../../../../../scss/live-event/base/session/questions.scss';
import './questions.scss';
import { ParamsProps } from '../../../../live-event/live-event';
import { getTextValue, updateTranslateKey } from '../../../../../utils/utils';
import { EContentColorOverrideNames } from '../../../../general-ui/edit-section-colors/edit-section-colors-modal';
import EditableTextSlim from '../../../../general-ui/editable-text/editable-text-slim';
import { updatePageModule } from '../../../../../store/actions/admin/create-event/session';
import InputSubmit from '../../../../live-event/session/session-modules/questions/input-submit';
import { getStylingOverrides } from '../../../../live-event/utils';
import Controls from '../session-module-controls/controls';
import { useTranslate } from '../../../../../i18n/useTranslationModules';
import QuestionsFilter from '../../../../general-ui/questions-filter';

import useTranslationRoute from '../../../../live-event/hooks/use-translation-route';

interface Props {
	page_module: PageModule;
	template: string;
}

export default function Questions(props: Props): JSX.Element | null {
	const { page_module, template } = props;
	const {
		workingSession,
	} = useSelector((state: EventsState) => state.CreateSessionReducer);
	const { language } = useParams() as ParamsProps;
	const namespace = useTranslationRoute();
	const { t } = useTranslate(['session', namespace]);
	const dispatch = useDispatch();

	const content = page_module?.content || GetDefaultQuestion();
	const stylingOverrides = page_module?.styling_overrides;
	const { backgroundColor, backgroundImg } = getStylingOverrides(stylingOverrides);

	function handleTextChange(key: string) {
		return (text: string) => {
			if (!workingSession) return;
			dispatch(
				updatePageModule({
					...page_module,
					content: {
						...content,
						[key]: updateTranslateKey({
							translateString: page_module?.content?.[key],
							input: text,
							baseLanguage: workingSession.default_language,
							language
						})
					},
					is_edited: true,
				})
			);
		};
	}
	function handleStyleOverrideChange(key: string) {
		return (overrides: TextOverrides) => {
			const updatedOverrides = {
				...stylingOverrides,
				content: {
					...stylingOverrides?.content,
					[key]: overrides
				}
			};
			dispatch(
				updatePageModule({
					...page_module,
					styling_overrides: updatedOverrides
				})
			);
		};
	}

	const { custom_heading } = getTextValue(content, language);

	return (page_module.is_on && (!workingSession?.layout?.withMenu || page_module)) ? (
		<div className={classNames(
			"editor-wrapper questions",
			backgroundColor,
			template
		)}
			style={backgroundImg}
		>
			<Controls
				page_module={page_module}
				openEditModal={() => ({})}
				display={{ editColors: true, changeSectionPosition: true }}
			/>
			<div className="container questions-container">
				<div className="questions-title-container">
					<EditableTextSlim
						tagType="h5"
						className="questions-title"
						value={t(`${namespace}:questions.${page_module.id}.heading`, t(`${namespace}:questions.heading`, custom_heading))}
						defaultColor={ColorKeys.bodyTextColor}
						onChange={handleTextChange('custom_heading')}
						onOverrideChange={handleStyleOverrideChange('custom_heading')}
						elementName={EContentColorOverrideNames.custom_heading}
						colorOverride={stylingOverrides?.content?.custom_heading?.color}
					/>
					<QuestionsFilter
						value={sortQuestionsOptions.newest}
						handleChange={() => ({})}
						template={template}
						displayOnly
					/>
				</div>
				<div className="questions-content">
					{/* <p>{t('questions.No questions yet')}</p> */}
					<InputSubmit
						module={page_module}
						placeholder={t("What is on your mind")}
						buttonText={t("Ask question")}
						onSubmitClick={() => { return Promise.resolve({}); }}
					/>
				</div>
			</div>
		</div>
	) : null;
}